import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsCommentModule } from '../../../evaluation/comment';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsCaEvaluationModule } from '../evaluation';
import { CmpsCaEvaluationToolbarModule } from '../evaluation/component/toolbar/toolbar.module';
import { CmpsCaScoreSectionModule } from '../score-section';

import { CaAnalysisDialogComponent } from './ca-analysis-dialog.component';
import { TranslationIdMap as DialogTranslationIdMap } from './ca-analysis-dialog.i18n';
import { CaAnalysisDialogService } from './ca-analysis-dialog.service';
import { CallBarComponent } from './component/call-bar/call-bar.component';

@NgModule({
    declarations: [CaAnalysisDialogComponent, CallBarComponent],
    providers: [CaAnalysisDialogService],
    imports: [
        CmpsButtonModule,
        CmpsCaEvaluationModule,
        CmpsCaEvaluationToolbarModule,
        CmpsCaScoreSectionModule,
        CmpsCommentModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsCaAnalysisDialogModule {}
